import { render, staticRenderFns } from "./MainLoader.vue?vue&type=template&id=d02066a0&scoped=true"
var script = {}
import style0 from "./MainLoader.vue?vue&type=style&index=0&id=d02066a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d02066a0",
  null
  
)

export default component.exports